import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CruiseShipsFilterService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCruiseShipsFiltered(
    startdate: string | undefined,
    enddate: string | undefined,
    region: string | undefined,
    theme: string | undefined,
    itinerary: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CruiseShipFilterInfo: JSON = <JSON>(<unknown>{
      startdate: startdate,
      enddate: enddate,
      region: region,
      theme: theme,
      itinerary: itinerary,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetShipsFiltered',
      JSON.stringify(CruiseShipFilterInfo),
      {
        headers: headers,
      }
    );
  }
}
